import { render, staticRenderFns } from "./invoiceList.vue?vue&type=template&id=bc6bc946&scoped=true&"
import script from "./invoiceList.vue?vue&type=script&lang=js&"
export * from "./invoiceList.vue?vue&type=script&lang=js&"
import style0 from "./invoiceList.vue?vue&type=style&index=0&id=bc6bc946&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc6bc946",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
